<template>
  <div>
    <div class="title-level">
      <h1 class="title">{{ `PO${orderID}` }}</h1>

      <w-chat />
    </div>

    <vs-table striped>
      <template #thead>
        <vs-tr>
          <vs-th sort @click="items = $vs.sortData($event, items, 'name')">Model Number</vs-th>
          <vs-th sort @click="items = $vs.sortData($event, items, 'qty')">QTY</vs-th>
          <vs-th sort @click="items = $vs.sortData($event, items, 'scheduled_ship_date')">Scheduled Ship Date</vs-th>
          <vs-th sort @click="items = $vs.sortData($event, items, 'note')">Note</vs-th>
          <vs-th sort @click="items = $vs.sortData($event, items, 'ship_date')">Vendor Ship Date</vs-th>
          <vs-th sort @click="items = $vs.sortData($event, items, 'shipped')">Shipped</vs-th>
          <vs-th sort @click="items = $vs.sortData($event, items, 'ship_method')">Ship Method</vs-th>
          <vs-th sort @click="items = $vs.sortData($event, items, 'tracking')">Tracking</vs-th>
          <vs-th>Action</vs-th>
        </vs-tr>
      </template>

      <template #tbody>
        <vs-tr v-for="item in items" :key="item.id" :data="item">
          <vs-td>{{ item.name }}</vs-td>
          <vs-td>{{ item.qty }}</vs-td>
          <vs-td>{{ formatDate(item.scheduled_ship_date) }}</vs-td>
          <vs-td>{{ item.note }}</vs-td>
          <vs-td>{{ formatDate(item.ship_date) }}</vs-td>
          <vs-td>{{ item.shipped }}</vs-td>
          <vs-td>{{ item.ship_method }}</vs-td>
          <vs-td>{{ item.tracking }}</vs-td>
          <vs-td><w-shipment :item="item" :shipment="item.shipment" /></vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import moment from 'moment';
import WChat from '../components/w-chat.vue';
import WShipment from '../components/w-shipment.vue';

export default {
  name: 'Order',

  components: {
    'w-chat': WChat,
    'w-shipment': WShipment,
  },

  data() {
    return {
      items: [],
    };
  },

  computed: {
    orderID() {
      return this.$route.params.orderID;
    },
  },

  created() {
    const order = this.$store.state.orders.filter((order) => {
      return order.id === this.orderID;
    })[0];

    order.contents.forEach((item) => {
      if (item.available > 0) {
        this.items.push({
          id: `i${item.id}`,
          itemID: item.id,
          name: item.name,
          qty: item.available || item.qty,
          scheduled_ship_date: item.scheduled_ship_date ? moment(item.scheduled_ship_date) : null,
          ship_date: null,
          shipped: 'No',
          ship_method: 'None',
          note: item.note || 'None',
          tracking: 'None',
        });
      }

      item.shipments.forEach((shipment) => {
        this.items.push({
          id: `s${shipment.id}`,
          itemID: item.id,
          name: item.name,
          available: item.available + shipment.qty,
          qty: shipment.qty,
          scheduled_ship_date: item.scheduled_ship_date ? moment(item.scheduled_ship_date) : null,
          ship_date: moment(shipment.ship_date),
          shipped: shipment.ship_method ? 'Yes' : 'No',
          ship_method: shipment.ship_method || 'None',
          note: item.note || 'None',
          tracking: shipment.tracking || 'None',
          shipment: shipment,
        });
      });
    });

    this.items.sort((a, b) => {
      if (a.id < b.id) {
        return -1;
      }

      if (a.id > b.id) {
        return 1;
      }

      return 0;
    });
  },

  methods: {
    formatDate(date) {
      if (date) {
        return date.format('ll');
      }

      return 'None';
    },
  },
};
</script>
